import Request from '@/utils/request'

export function holidayActBaseInfo() {
  return Request({
    url: `/api/v2/app/activity/xmas/home`,
    method: 'get'
  })
}

export function holidayActRank() {
  return Request({
    url: `/api/v2/app/activity/xmas/rank`,
    method: 'get'
  })
}

export function holidayDaySign() {
  return Request({
    url: `/api/v2/app/activity/xmas/daily/sign`,
    method: 'post'
  })
}

export function holidayDayClaim(taskId) {
  return Request({
    url: `/api/v2/app/activity/xmas/daily/claim?taskId=${taskId}`,
    method: 'post'
  })
}

export function holidayMilesClaim() {
  return Request({
    url: `/api/v2/app/activity/xmas/milestone/claim`,
    method: 'post'
  })
}
